<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { defineEmits, withDefaults, defineProps } from "vue";

const { t } = useI18n();

withDefaults(
  defineProps<{
    btnWidth?: string;
    btnTextKey?: string;
  }>(),
  {
    btnTextKey: "buttons.add",
    btnWidth: "w-[125px]",
  }
);

defineEmits(["clicked"]);
</script>

<template>
  <button
    class="flex items-center gap-[10px] h-11 px-[10px] rounded-lg border border-brown"
    :class="btnWidth"
    @click="$emit('clicked')"
  >
    <!-- PLUS ICON -->
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99984 4.16797V15.8346M4.1665 10.0013H15.8332"
        stroke="#1E1E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- TEXT -->
    <span class="flex-1 text-black text-base leading-[20px]">
      {{ t(btnTextKey) }}
    </span>
  </button>
</template>
